module.exports = __webpack_public_path__ + "img/emblem_3.efa2f14f.svg";